import React from 'react';

const Section = ({ id, label, children }) => {
  return (
    <section id={id} className="scroll-mt-28">
      <h2 className="mb-8 font-display text-2xl font-semibold tracking-tight text-ink sm:mb-10">
        {label}
      </h2>
      {children}
    </section>
  );
};

export default Section;
